// src/config/navigation.ts

export type NavBase = {
  key: string;
  titleKey: string;
};

export type NavLink = NavBase & {
  type: "link";
  href: string;
};

export type NavGroupRef = NavBase & {
  type: "group";
};

export type NavDynamic = NavBase & {
  type: "dynamic";
};

export type MainNavItem = NavLink | NavGroupRef | NavDynamic;

export const navigationConfig = {
  main: [
    {
      key: "pricing",
      titleKey: "header.navigation.items.proxies.title",
      type: "group",
    },
    {
      key: "use_cases",
      titleKey: "header.navigation.items.use_cases.title",
      type: "dynamic",
    },
    {
      key: "locations",
      titleKey: "header.navigation.items.locations.title",
      href: "/locations",
      type: "link",
    },
    {
      key: "blog",
      titleKey: "header.navigation.items.blog.title",
      href: "/blog",
      type: "link",
    },
    {
      key: "free_tools",
      titleKey: "header.navigation.items.free_tools.title",
      type: "group",
    },
  ] satisfies MainNavItem[],

  // Proxies menu config (unchanged)
  proxiesGroup: {
    key: "proxies",
    titleKey: "header.navigation.items.proxies.title",
    featured: {
      titleKey: "header.navigation.items.proxies.featured.title",
      descriptionKey: "header.navigation.items.proxies.featured.description",
      href: "https://dashboard.thunderproxy.com/auth/register",
    },
    items: [
      {
        key: "residential",
        titleKey: "header.navigation.items.proxies.items.residential.title",
        descriptionKey: "header.navigation.items.proxies.items.residential.description",
        href: "/products/proxies/residential-proxies",
        basePrice: "$3.49",
        baseUnit: "globals.base_gb_unit",
      },
      {
        key: "datacenter",
        titleKey: "header.navigation.items.proxies.items.datacenter.title",
        descriptionKey: "header.navigation.items.proxies.items.datacenter.description",
        href: "/products/proxies/datacenter-proxies",
        basePrice: "$0.99",
        baseUnit: "globals.base_gb_unit",
      },
      {
        key: "isp",
        titleKey: "header.navigation.items.proxies.items.isp.title",
        descriptionKey: "header.navigation.items.proxies.items.isp.description",
        href: "/products/proxies/isp-proxies",
        basePrice: "$1.81",
        baseUnit: "globals.base_ip_unit",
      },
    ],
  },

  freeToolsGroup: {
    key: "free_tools",
    titleKey: "header.navigation.items.free_tools.title",
    items: [
      {
        key: "proxy_checker",
        titleKey: "header.navigation.items.free_tools.items.proxy_checker.title",
        descriptionKey: "header.navigation.items.free_tools.items.proxy_checker.description",
        href: "/free-tools/proxy-checker",
      },
    ],
  },
};
